<app-loader class="loader" [ngStyle]="{ display: displayStyles }"></app-loader>
<div style="position: fixed; top: 0; width: 100%; z-index: 10">
  <app-navbar></app-navbar>
</div>
<div class="foot" style="padding-top: 10rem">
  <div class="heading-rounds-white">
    <h2><span class="headi">GALLERY</span></h2>
  </div>
  <div class="container">
    <div
      class="tf-step wow fadeInUp"
      data-wow-delay="0.2s"
      *ngFor="let lis of lift"
    >
      <!-- <a href="{{ lis.link }}" target="_blank"> -->
        <div class="img-container" style="text-align: center">
          <!-- <span class="img-grad"></span> -->
          <img class="inner-img" src="{{ lis.img }}" />
        </div>
      <!-- </a> -->

      <!-- <div class="img-text">
        <hr />

        <h2 style="font-weight: 800; text-align: left">{{ lis.title }}</h2>
        <p>{{ lis.desc }}</p>
      </div> -->
    </div>
  </div>
  <!-- <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
	<div class="tf-step wow fadeInUp" data-wow-delay="0.2s">
		<div class="step-title">
			<div class="sub-number">
				01
			</div>
			<h3>This is the title</h3>
		</div>
		<p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quisquam magni fuga possimus vero voluptate nostrum quasi. Perspiciatis hic non doloribus quae itaque maiores nihil nobis eius, fugiat doloremque quos natus aliquam, quo aliquid deserunt.</p>
	</div>
</div> -->
  <app-footer></app-footer>
</div>
